import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Card from './styled-components/Card'
import HeaderText from './styled-components/HeaderText'
import HeaderTextSmall from './styled-components/HeaderTextSmall'
import { AnovaLogoSmall } from './AnovaLogo'
import { TermsOfServiceAndPrivacyPolicy } from './TermsOfServiceAndPrivacyPolicy'
import ButtonRow from './styled-components/ButtonRow'
import { ButtonPrimary } from './styled-components/Button'
import Form, { FormInputs } from './styled-components/Form'
import MaterialTextField from './styled-components/MaterialTextField'
import EmailText from './EmailText'
import errorMessages from '../errorMessages'
import ShowHidePasswordButton from './styled-components/ShowHidePasswordButton'
import { analyticsPage } from '../analytics'

class MakeNewPasswordForm extends Component {
  state = {
    showPassword: false
  }

  async componentDidMount () {
    analyticsPage('ALI Password Reset - New Password Form')
    await this.props.checkFirebasePasswordResetCodeAndSetEmail()
  }

  showOrHidePassword = () => this.setState({ showPassword: !this.state.showPassword })

  resetPassword = async (event) => {
    event.preventDefault()
    await this.props.resetPassword()
  }

  render () {
    return (
      <Card data-email-confirmation-failed>
        {this.props.invalidActionCode || this.props.expiredActionCode || this.props.userNotFound ? <Redirect to="/password-reset-failure" /> : null}
        {this.props.redirectToPasswordChanged ? <Redirect to="/password-changed" /> : null}

        <div>
          <AnovaLogoSmall />
        </div>

        <Form onSubmit={this.resetPassword}>
          <HeaderText>Make a new password</HeaderText>
          <HeaderTextSmall>for&nbsp;
            <EmailText email={this.props.email} />
          </HeaderTextSmall>
          <FormInputs>
            <ShowHidePasswordButton
              onClick={this.showOrHidePassword}
              showPassword={this.state.showPassword}
            />
            <MaterialTextField
              showErrorText={this.props.weakPassword}
              errorMessage={errorMessages.weakPassword}
              type={this.state.showPassword ? 'text' : 'password'}
              label="Password"
              autoFocus={true}
              onChange={event => this.props.handlePasswordChangeAndClearPasswordErrors(event.target.value)}
              value={this.props.password}
              name="passwordInput">
            </MaterialTextField>
          </FormInputs>

          <ButtonRow>
            <ButtonPrimary
              type="submit"
              disabled={!this.props.password}
              data-save-button>
              SAVE
            </ButtonPrimary>
          </ButtonRow>
        </Form>

        <TermsOfServiceAndPrivacyPolicy />
      </Card>
    )
  }
}

export default MakeNewPasswordForm
